import React from 'react'
import { seriliazeParams } from '../../../helpers/seriliazeParams';
import { get_checkride_table, get_checkride_table_by_Id, get_employee_listing_not_Terminated } from '../../../Services/employee';
import moment from 'moment';
import { useEffect } from 'react';
import DynamicTable from '../../../Components/TableComponents/DynamicTable';
import { useState } from 'react';
import { checkRidesColumns } from '../../../Components/TableComponents/constants';
import { Button, Col, Row, Select } from 'antd';
import { EyeFilled, EyeInvisibleFilled, EyeOutlined } from '@ant-design/icons';
import { useHistory } from 'react-router-dom';
import roleManager from '../../../Components/roles';

const CheckRideTab = () => {

  const history = useHistory();
  const [CheckRideData, setCheckRideData] = useState({ header: [], rows: [] })
  const [EmployeeListData, setEmployeeListData] = useState([])
  const [filters, setFilters] = useState({
    engineer: null,
    evaluator: null,
  })


  const handleAddEvent = (event, tabIndex) => {
    history.push(event);
  }

  const getEmployeeData = async () => {
    let result = await get_employee_listing_not_Terminated()
    if (result?.httpStatus === 200) {
      const data = result?.data.map((item, index) => {
        return {
          label: `${item?.firstName} ${item?.lastName}`,
          value: item?.id
        }
      })
      setEmployeeListData(data)
    }
  }

  const handleButtonClick = async (id, activeKey) => history.push({ pathname: '/checkRidePdf', state: { id, activeKey: 2 } })


  const getcheckRide = async (offset = 0, limit = 10) => {
    let params = '?'.concat(seriliazeParams({ offset, limit, EngineerId: filters?.engineer, EvaluatorId: filters?.evaluator }))
    let data = await get_checkride_table({ params });
    if (data.httpStatus == 200) {
      data = data?.data
      data?.forEach(element => {
        element.date = moment(new Date(element?.date)).utc().format('MM-DD-YYYY')
        element.time = element?.time?.slice(0, -3)
      });
      setCheckRideData(
        {
          header: checkRidesColumns,
          rows: data.map(row => [
            row?.id,
            row?.EngineerId + " / " + row?.Engineer?.firstName + " " + row?.Engineer?.lastName,
            row?.Type,
            row?.date,
            row?.locomotiveConsist,
            row?.TCLoads,
            row?.TCEmpties,
            row?.TCTotalTonage,
            row?.TMTraveled,
            row?.totalScore,
            // <Button className="ViewIcon"></Button>
            <Button style={{ border: 'none' }} onClick={() => handleButtonClick(row?.id)}><EyeOutlined /></Button>,
          ])
        }
      )
    }
  }


  useEffect(() => {
    getEmployeeData();
  }, []);

  useEffect(() => {
    getcheckRide();
  }, [filters?.engineer, filters?.evaluator]);


  return (
    <div>

      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '20px' }}>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start' }}>
          {roleManager("safetyTesting", "CreatecheckRide") && (
            <Button
              onClick={handleAddEvent.bind(null, 'enter-check-ride', 1)}
              style={{ background: '#2963AD ', color: 'white', borderRadius: "10px", height: '50px' }} >
              Enter Checkride
            </Button>
          )}
        </div>

        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', gap: "10px" }}>
          <Button onClick={() => setFilters({ engineer: null, evaluator: null })} style={{ width: '100px', backgroundColor: "#2963ad", color: "white" }}>Reset Filter</Button>
          {roleManager("custom_conditions", "check_ride_select_filter") ? (
            <Select
              style={{ width: "100%", marginBottom: '' }}
              showSearch
              optionFilterProp="children"
              onChange={value => setFilters(prev => { return { ...prev, evaluator: value } })}
              filterOption={(input, option) => (option?.label ?? '').toLowerCase().includes(input.toLowerCase())}
              placeholder={`Select Evaluator`}
              options={EmployeeListData}
              value={filters?.evaluator}
            />
          ) : null}
          <Select
            style={{ width: "100%", marginBottom: '' }}
            showSearch
            optionFilterProp="children"
            onChange={value => setFilters(prev => { return { ...prev, engineer: value } })}
            filterOption={(input, option) => (option?.label ?? '').toLowerCase().includes(input.toLowerCase())}
            placeholder={`Select Engineer`}
            options={EmployeeListData}
            value={filters?.engineer}
          />
        </div>
      </div>


      <DynamicTable tableData={CheckRideData} />
    </div>)

}

export default CheckRideTab